export const SET_USUARIO = 'SET_USUARIO';

export const accionSetUsuario = (usuario) => ({
    type: SET_USUARIO, usuario
});